(() => {
  if (customElements.get('nv-vang-hello')) return;
  customElements.define('nv-vang-hello', class extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.timer);
      const deadline = Date.parse(this.dataset.deadline);
      const clock = this.querySelector('[data-vang-hello-clock]');
      const label = this.querySelector('[data-vang-hello-label]');
      if (!Number.isFinite(deadline) || !clock || !label) return;
      const tick = () => {
        if (!this.isConnected) return;
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        if (!remaining) {
          label.textContent = this.dataset.live;
          clock.hidden = true;
          return;
        }
        clock.hidden = false;
        clock.textContent = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(n => String(n).padStart(2, '0')).join(':');
        this.timer = setTimeout(tick, 1000);
      };
      tick();
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
})();
